import service from '@/services/superaccess'

const trafic_board = {
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    retrieveDataTraficBoard (context, payload) {
      return service.post('/api/trafic_board', context, payload)
    },
    retrieveMovementsCP (context, payload) {
      return service.get(`/api/trafic_board/control_point/${payload}`, context)
    },
    retrieveDataSurveillance (context, payload) {
      return service.post('/api/trafic_board/surveillance', context, payload)
    }
  }
}

export default trafic_board



// WEBPACK FOOTER //
// app/javascript/src/store/trafic_board.js